import Cookies from "js-cookie"

const COOKIE_NAME = 'hint_read'
const COOKIE_EXPIRES = 365

function getReadHints(): string[] {
    const value = Cookies.get(COOKIE_NAME)
    if (!value) return []
    try {
        const parsed: unknown = JSON.parse(value)
        return Array.isArray(parsed) ? parsed.map(String) : []
    } catch {
        return []
    }
}

function markAsRead(hintId: string): void {
    const ids = getReadHints()
    if (!ids.includes(hintId)) {
        ids.push(hintId)
        Cookies.set(COOKIE_NAME, JSON.stringify(ids), {expires: COOKIE_EXPIRES, sameSite: 'Lax'})
    }
}

jQuery.fn.extend({
    "hintArea": function (this: JQuery) {
        this.each(function () {
            const area = $(this)
            const hintId = String(area.data('hint'))

            // 未読なら表示
            if (!getReadHints().includes(hintId)) {
                area.show()
            }

            // 閉じるボタン
            area.find('.close').on('click', function () {
                markAsRead(hintId)
                area.fadeOut()
                return false
            })
        })
    },
})
